export const chatBoxContainerStyles =
   'absolute flex flex-col overflow-hidden z-40'

export const mobileChatBoxContainerStyles = 'inset-0 '

export const getDesktopChatBoxContainerStyles = (isExpanded: boolean | null) =>
   `bottom-6 right-6 w-[500px] h-[700px] border shadow-xl rounded-2xl ${
      isExpanded !== null
         ? isExpanded
            ? 'h-[95%] w-[97%] animate-[chat-box-expand-keyframe_300ms]'
            : 'animate-[chat-box-collapse-keyframe_300ms]'
         : 'animate-[chat-box-open-keyframe_300ms]'
   }`

export const headerContainerStyles =
   'flex items-center gap-4 m-5 pb-4 border-b border-gray-300 !mb-0'

export const popoverBodyContainer = 'px-8px pt-8px w-full'

export const chatIframeContainerStyles = 'flex-1 w-full'

export const historyPopoverHeaderContainer = `flex items-center justify-between px-8px py-6px mb-16px`

export const historyAndRefreshContainer = `flex items-center`

export const getHistoryTitleStyles = (theme: any): string =>
   `text-md-semibold ml-8px ${theme.historyTextColor}`

export const getHistoryOptionContainerStyles = (theme: any): string =>
   `flex items-center pl-[14px] w-full py-12px pr-16px mb-8px 
    rounded-8px outline-none ${theme.historyOptionHoverColor}`

export const historyOptionTitleStyles = (theme: any): string =>
   `text-sm-medium ml-8px truncate ${theme.historyOptionTextColor}`

export const clockIconContainer =
   'flex items-center justify-center outline-none'

export const menuOptionsListContainer = `
   md:p-[6px] gap-y-[16px]  md:gap-y-[2px] 
   flex flex-col w-full
`

export const menuOptionContainer = `
   flex items-center 
   p-[10px] pl-[8px] 
   rounded-lg  
   cursor-pointer
`

export const menuOptionText = `
   ml-2 
   truncate 
   text-sm-medium
`
